class HeaderMegaMenu extends HTMLElement {
  constructor() {
    super();

    this.selectedIndex = this.selectedIndex;
    this.buttons.forEach((button, index) => button.addEventListener('click', () => this.changeActive(index)));

    // this.load()

    if (Shopify.designMode) {
      this.addEventListener('shopify:block:select', (event) => this.selectedIndex = this.buttons.indexOf(event.target));
    }
  }

  get selectedIndex() {
    return parseInt(this.getAttribute('selected-index')) || 0;
  }

  set selectedIndex(index) {
    this.setAttribute('selected-index', Math.min(Math.max(index, 0), this.buttons.length - 1).toString());
  }

  get buttons() {
    return this._buttons = this._buttons || Array.from(this.querySelectorAll('li[role="tab"]'));
  }

  // load() {
  //   const toButton = this.buttons[parseInt(this.selectedIndex)];
  //   if (toButton === undefined) return;

  //   const toPanel = this.querySelector('li[role="tabpanel"][id="' + toButton.getAttribute('data-id') + '"]');
  //   toPanel.hidden = false;
  //   Motion.animate(toPanel, { transform: ['translateY(2rem)', 'translateY(0)'], opacity: [0, 1] }, { duration: theme.config.motionReduced ? 0 : 0.15 }).finished;
  //   toPanel.querySelector('motion-list')?.load();
  // }

  // unload() {
  //   const fromButton = this.buttons[parseInt(this.selectedIndex)];
  //   if (fromButton === undefined) return;

  //   const fromPanel = this.querySelector('li[role="tabpanel"][id="' + fromButton.getAttribute('data-id') + '"]');
  //   Motion.animate(fromPanel, { transform: ['translateY(0)', 'translateY(2rem)'], opacity: [1, 0] }, { duration: theme.config.motionReduced ? 0 : 0.15 }).finished;
  //   fromPanel.querySelector('motion-list')?.unload();
  // }

  changeActive(index) {
    if (this.selectedIndex !== index) {
      const fromButton = this.buttons[parseInt(this.selectedIndex)];
      const toButton = this.buttons[parseInt(index)];
      // 切换选中样式
      fromButton.classList.remove('active');
      toButton.classList.add('active');

      const fromPanel = this.querySelector('li[role="tabpanel"][id="' + fromButton.getAttribute('data-id') + '"]');
      const toPanel = this.querySelector('li[role="tabpanel"][id="' + toButton.getAttribute('data-id') + '"]');
    
      fromPanel.hidden = true;
      toPanel.hidden = false;
    
      Motion.animate(toPanel, { transform: ['translateY(2rem)', 'translateY(0)'], opacity: [0, 1] }, { duration: theme.config.motionReduced ? 0 : 0.15 }).finished;
      toPanel.querySelector('motion-list')?.load();
      }
      this.selectedIndex = index
  }
}
if (!customElements.get('header-mega-menu')) {
  customElements.define('header-mega-menu', HeaderMegaMenu);
}